import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=4a89e2e5&scoped=true"
import script from "./_category.vue?vue&type=script&lang=js"
export * from "./_category.vue?vue&type=script&lang=js"
import style0 from "./_category.vue?vue&type=style&index=0&id=4a89e2e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89e2e5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShimmerEffect: require('/workspace/components/ShimmerEffect.vue').default,EventCardGeneral: require('/workspace/components/EventCardGeneral.vue').default})
